import { FolderGit2, FolderX, MessageSquare, Server, Trash2 } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "../ui/card";
import { Badge } from "../ui/badge";
import { CATEGORIES, CATEGORY_STYLE, DEFAULT_STYLE } from "./categories";

const STATUS_LABEL = {
  active: "Activo",
  maintenance: "Mantenimiento",
  paused: "Pausado",
};

export function ProjectCard({ project, onOpen, onManageServers, onDelete, onChangeCategory }) {
  const style = CATEGORY_STYLE[project.category] || DEFAULT_STYLE;
  const { Icon } = style;
  return (
    <Card
      data-testid={`project-card-${project.id}`}
      onClick={() => onOpen(project.id)}
      className={`group relative cursor-pointer overflow-hidden border-border/70 bg-card transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg ${style.hover}`}
    >
      <div data-testid={`project-stripe-${project.id}`} className={`h-1 w-full bg-gradient-to-r ${style.stripe}`} />
      <CardHeader className="pb-2">
        <div className="flex items-start justify-between gap-2">
          <div className="flex min-w-0 items-center gap-2">
            <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-muted/60 ${style.text}`}>
              <Icon className="h-4 w-4" />
            </span>
            <CardTitle className="truncate text-base">{project.name}</CardTitle>
          </div>
          <Badge variant={project.status === "active" ? "default" : "secondary"} className="shrink-0">
            {STATUS_LABEL[project.status] || project.status}
          </Badge>
        </div>
        <CardDescription className="line-clamp-2">
          {project.description || "Sin descripción todavía."}
        </CardDescription>
      </CardHeader>
      <CardContent className="pb-2">
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          {project.drive_folder ? (
            <>
              <FolderGit2 className="h-3.5 w-3.5 shrink-0" />
              <span className="truncate">{project.drive_folder}</span>
            </>
          ) : (
            <>
              <FolderX className="h-3.5 w-3.5 shrink-0" />
              <span>Sin carpeta de Drive</span>
            </>
          )}
        </div>
        {onChangeCategory && (
          <select
            data-testid={`project-category-${project.id}`}
            aria-label="Tipo de proyecto"
            value={project.category || ""}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => onChangeCategory(project, e.target.value)}
            className={`mt-2 h-7 rounded-full border border-input bg-muted/40 px-2.5 text-xs ${project.category ? style.text : "text-muted-foreground"}`}
          >
            <option value="">Sin tipo</option>
            {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        )}
      </CardContent>
      <CardFooter className="pt-0 flex items-center justify-between">
        <span className="inline-flex items-center gap-1.5 text-xs text-emerald-500">
          <MessageSquare className="h-3.5 w-3.5" /> Abrir chat
        </span>
        <div className="flex items-center gap-3">
          {onManageServers && (
            <button
              type="button"
              data-testid={`project-servers-${project.id}`}
              onClick={(e) => {
                e.stopPropagation();
                onManageServers(project);
              }}
              className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground"
            >
              <Server className="h-3.5 w-3.5" /> Servidores
            </button>
          )}
          {onDelete && (
            <button
              type="button"
              data-testid={`project-delete-${project.id}`}
              title="Eliminar proyecto"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(project);
              }}
              className="inline-flex items-center text-muted-foreground hover:text-red-500"
            >
              <Trash2 className="h-3.5 w-3.5" />
            </button>
          )}
        </div>
      </CardFooter>
    </Card>
  );
}
